<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/why-codesroots.png" alt="seo" />
            </div>
            <div class="col-md-6">
                <div class="service">
                    <h2 class="section-title" style="line-height: 1.2;">
                        {{"Why codesroots web design services?" | translate}}
                    </h2>
                    <ul class="fa-ul text-right">
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1">
                            {{"Share your site on wikis, gov sites, and forums" | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1">
                            {{"Backlinks Do Follow in websites, forums and search engines" | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1">
                            {{"Subscription to the Google Analytics service to monitor the status of visitors and analyze how to access" | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1">

                            {{"An account on Google Webmaster Tools to follow up on website links and fix errors" | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1">
                            {{"Create sitemaps [ xml, txt, php, xml.gz ]" | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1">
                            {{"Enable an RSS feed within your site" | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1">
                            {{"Installing a VB SEO or WP SEO plugin, depending on your site" | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1">
                            {{"Check, analyze and adjust Meta Tags for your site" | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1">
                            {{"Provide advice on the content of the site" | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1">
                            {{"Site analysis, bug fixes and archiving problems" | translate}}
                          </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
